import { baseJobValidation } from "form-validations/base-job-validation";

export const validate = values => {
  return baseJobValidation(values)
};
